import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Collapse,
  Container,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect, useRef, useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import React from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { auth } from "../firebase"; // Ensure correct path to firebase.js

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius
}));

const Login = ({ history }) => {
  const emailRef = useRef();
  const passwordRef = useRef();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const [matches, setMatches] = useState(
    window.matchMedia("(min-width: 768px)").matches
  );
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  // async function handleSubmit(e) {
  //   e.preventDefault();
  //   try {
  //     setLoading(true);
  //     // await login(emailRef.current.value, passwordRef.current.value);
  //   } catch {
  //     setError("Failed to log in");
  //     setOpen(true);
  //   }
  //   setLoading(false);
  // }

  useEffect(() => {
    // Redirect if already authenticated
    if (localStorage.getItem("isAuthenticated") === "true") {
      const role = localStorage.getItem("userRole");
      redirectBasedOnRole(role);
    }
  }, [history]);

  // async function handleSubmit(e) {
  //   e.preventDefault();
  //   setLoading(true);
  //   setError(""); // Reset error before attempting login

  //   const email = emailRef.current.value;
  //   const password = passwordRef.current.value;
  //   const API_URL = "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyBfKaXtkDKYpyauMSd-MA_ReSYtP0n6Hus";

  //   try {
  //     const { data } = await axios.post(API_URL, {
  //       email,
  //       password,
  //       returnSecureToken: true
  //     });

  //     localStorage.setItem('isAuthenticated', 'true');
  //     localStorage.setItem('name', data.displayName);
  //     console.log("Login Successful:", data.displayName);
  //     history.push("/home");
  //     // Handle successful login (store token, redirect, update state)
  //   } catch (error) {
  //     setError(
  //       (error.response && error.response.data && error.response.data.error && error.response.data.error.message) ||
  //       "Failed to log in"
  //     );
  //     setOpen(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // }
  // Redirect users based on role
  const redirectBasedOnRole = role => {
    if (role === "Admin") {
      history.push("/home");
    } else if (role === "Expert") {
      history.push("/feedback/summary");
    } else if (role === "superAdmin") {
      history.push("/home");
    } else {
      history.push("/home");
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError(""); // Reset error before attempting login

    const email = emailRef.current.value;
    const password = passwordRef.current.value;

    try {
      const userCredential = await auth.signInWithEmailAndPassword(
        email,
        password
      );
      const user = userCredential.user;

      // Get user token
      const token = await user.getIdToken(true); // Force refresh token
      const tokenResult = await user.getIdTokenResult(); // Fetch role from Firebase custom claims

      let role = "user";
      if (tokenResult.claims["superAdmin"]) {
        role = "superAdmin";
      } else if (tokenResult.claims["Admin"]) {
        role = "Admin";
      } else if (tokenResult.claims["Expert"]) {
        role = "Expert";
      }
      console.log("User Role:", role);
      // Store authentication details
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("userToken", token); // Store token
      localStorage.setItem("name", user.displayName || "User"); // Fallback if displayName is null
      localStorage.setItem("userRole", role); // Store token if needed
      window.dispatchEvent(new Event("storage"));
      console.log("Login Successful:", user.displayName);
      console.log("Auth Token:", token);
      redirectBasedOnRole(role);
      // history.push("/home"); // Redirect after successful login
    } catch (error) {
      setError(error.message || "Failed to log in");
      setOpen(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Collapse in={open} style={{ zIndex: 1 }}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          {error}
        </Alert>
      </Collapse>
      <Box sx={{ flexGrow: 1 }} style={{ backgroundColor: "transparent" }}>
        <Grid container sx={{ height: "100vh" }}>
          <Grid
            item
            sm={12}
            md={12}
            sx={{
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              margin: "auto"
            }}
          >
            {matches && (
              <>
                {/* <StyledBox sx={{ width: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'transparent' }}>
                  <img src="/Agrim.png" alt="brand" width="35%" height="auto" />
                </StyledBox> */}
                <Box sx={{ width: "50%", margin: "auto" }}>
                  <FormControl
                    onSubmit={handleSubmit}
                    className="shadow-lg p-5 bg-body rounded"
                    margin="normal"
                    variant="outlined"
                    fullWidth
                    sx={{ gap: 6 }}
                  >
                    {/* <Typography variant="h3" sx={{ color: "#253252", textAlign: "center" }}>
                      <b></b>
                    </Typography> */}
                    <StyledBox
                      sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "transparent"
                      }}
                    >
                      <img
                        src="/Agrim.png"
                        alt="brand"
                        width="45%"
                        height="auto"
                      />
                    </StyledBox>
                    <TextField required label="Username" inputRef={emailRef} />
                    <TextField
                      required
                      label="Password"
                      type={showPassword ? "text" : "password"}
                      inputRef={passwordRef}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={handleClickShowPassword}>
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    <Button onClick={handleSubmit} variant="contained">
                      Sign in
                    </Button>
                  </FormControl>
                </Box>
              </>
            )}
            {!matches && (
              <>
                <Box
                  className=" p-3 mb-5 bg-body rounded m-auto"
                  sx={{ bgcolor: "#ffffff", width: "75%" }}
                >
                  <item>
                    <img
                      // src="./images/napino_logo.png"
                      src="/images/logocd.png"
                      alt="brand"
                      width="45%"
                      height="auto"
                      className="d-block m-auto text-center"
                    />
                  </item>
                  {/* <Typography
                  className="font-login text-center"
                  variant="h4"
                  sx={{ fontsize: "3rem" }}
                  style={{ color: "#253252" }}
                >
                  <b>Water Supply Management System</b>
                </Typography> */}
                </Box>
                <Box
                  sx={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: "75%",
                    margin: "auto"
                  }}
                >
                  <FormControl
                    onSubmit={handleSubmit}
                    className="shadow-lg p-3 mb-5 bg-body rounded"
                    margin="normal"
                    variant="outlined"
                    fullWidth={true}
                    sx={{ gap: 6, padding: 2 }}
                  >
                    {/* <Typography variant="h3" sx={{ color: "primary.main" }}>
                    Sign in
                  </Typography> */}
                    <StyledBox
                      sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "transparent"
                      }}
                    >
                      <img
                        src="/Agrim.png"
                        alt="brand"
                        width="45%"
                        height="auto"
                      />
                    </StyledBox>
                    <TextField required label="Username" inputRef={emailRef} />
                    <TextField
                      required
                      label="Password"
                      type="Password"
                      inputRef={passwordRef}
                    />
                    <Button onClick={handleSubmit} variant="contained">
                      Sign in
                    </Button>
                  </FormControl>
                </Box>
              </>
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default withRouter(Login);
